var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m66.5,73.5l7-7-18.5-18.5v-23h-10v27l21.5,21.5Zm-16.5,26.5c-6.92,0-13.42-1.31-19.5-3.94s-11.38-6.19-15.88-10.69-8.06-9.79-10.69-15.88S0,56.92,0,50s1.31-13.42,3.94-19.5,6.19-11.38,10.69-15.88S24.42,6.56,30.5,3.94,43.08,0,50,0s13.42,1.31,19.5,3.94,11.38,6.19,15.88,10.69,8.06,9.79,10.69,15.88,3.94,12.58,3.94,19.5-1.31,13.42-3.94,19.5-6.19,11.38-10.69,15.88-9.79,8.06-15.88,10.69-12.58,3.94-19.5,3.94Zm0-10c11.08,0,20.52-3.9,28.31-11.69,7.79-7.79,11.69-17.23,11.69-28.31s-3.9-20.52-11.69-28.31-17.23-11.69-28.31-11.69-20.52,3.9-28.31,11.69c-7.79,7.79-11.69,17.23-11.69,28.31s3.9,20.52,11.69,28.31c7.79,7.79,17.23,11.69,28.31,11.69Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/ClockIcon.3ad26ba3c0fe7a584d04f46ef1deee54.svg";
export { ForwardRef as ReactComponent };